module.exports = __webpack_public_path__ + "static/media/download-iphone.f5a3cdbe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/begamer/download-iphone.jpg
// module id = 972
// module chunks = 0